// extracted by mini-css-extract-plugin
export default {"createSelectOption":"BimCreateLimitedNameSelect_createSelectOption__s+KbL"};